import classNames from "classnames";

// Hooks
import useTranslate from "hooks/useTranslate";

// Icons
import NotificationIcon from "assets/icons/glory/info_notifications.svg?react";
import PromoIcon from "assets/icons/glory/promo.svg?react";

// Types
import { NotificationType, TypeNotification } from "redux/notification/slice";

import "./styles.sass";

type NotificationProps = {
  notification: NotificationType;
};

const Notification = (props: NotificationProps) => {
  const { notification } = props;

  const t = useTranslate();

  const notificationClass = classNames("Notification__circle", {
    active: !notification.isRead,
  });

  const amountClass = classNames("Notification-main__amount", {
    "Notification-main__amount_withdrawal":
      notification.type === TypeNotification.WITHDRAWAL,
  });
  const sign = (): string => {
    if (notification.type === TypeNotification.DEPOSIT) {
      return "+";
    }
    if (notification.type === TypeNotification.WITHDRAWAL) {
      return "-";
    }
    return "";
  };
  return (
    <div className="Notification">
      <span className={notificationClass} />
      {notification.type === TypeNotification.PROMO ? (
        <PromoIcon />
      ) : (
        <NotificationIcon />
      )}
      <div className="Notification-main">
        <div className="Notification-main__title">{t(notification.title)}</div>
        <div>
          <span className="Notification-main__text">
            {t(notification.text)}
          </span>
          <span
            className={amountClass}
          >{` ${sign()}${notification.amount} ${notification.currency}`}</span>
        </div>
        <div className="Notification-main__date">{notification.date}</div>
      </div>
    </div>
  );
};

export default Notification;
